module.exports = __webpack_public_path__ + "static/dpf_reinigung-ee384740d9bc500ee3b0adaa93a2899c.jpg";